import { MIN_SCREEN_HEADER_HEIGHT, WORKSPACE_FRAME_PADDING } from '@components/v2/constants';
import { BOTTOMBAR } from '@components/v2/layout/AppTemplate/appTemplate.consts';
import TeceoLogo from '@components/v2/ui/TeceoLogo/TeceoLogo';
import { Box, Stack } from '@mui/material';
import ErrorScreenContent from './components/ErrorScreenContent';
import { ErrorScreenProps } from './errorScreen.types';

const LOGO_WIDTH = 91;
const HEADER_INLINE_SPACING = 3;
const CONTENT_RIGHT_SPACING = 1;

const CONTENT_INLINE_OFFSET = {
  xs: '10vw',
  sm: '21vw',
  md: '11.7vw',
  lg: '11.7vw',
  xl: '17.5vw',
};

const ErrorScreen = ({ slots, testId, ...content }: ErrorScreenProps) => {
  return (
    <Box
      test-id={testId}
      sx={{
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100dvh',
        backgroundColor: 'background.paper',
      }}
    >
      <Stack
        component="header"
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          minHeight: MIN_SCREEN_HEADER_HEIGHT,
          alignItems: 'flex-start',
          justifyContent: 'center',
          paddingInline: HEADER_INLINE_SPACING,
        }}
      >
        <TeceoLogo width={LOGO_WIDTH} />
      </Stack>

      <Stack
        role="alert"
        sx={{
          flex: 1,
          justifyContent: 'center',
          paddingBlock: `${MIN_SCREEN_HEADER_HEIGHT}px ${BOTTOMBAR.height}px`,
          paddingRight: CONTENT_RIGHT_SPACING,
          paddingLeft: CONTENT_INLINE_OFFSET,
        }}
      >
        <ErrorScreenContent {...content} />
      </Stack>

      {slots?.footer && (
        <Stack
          component="footer"
          direction="row"
          sx={{
            position: 'absolute',
            left: 0,
            right: 0,
            bottom: 0,
            height: BOTTOMBAR.height,
            alignItems: 'center',
            justifyContent: 'flex-end',
            paddingInline: WORKSPACE_FRAME_PADDING,
          }}
        >
          {slots.footer}
        </Stack>
      )}

      {slots?.banner && (
        <Box sx={{ position: 'absolute', left: 0, right: 0, bottom: 0 }}>{slots.banner}</Box>
      )}
    </Box>
  );
};

ErrorScreen.displayName = 'ErrorScreen';

export default ErrorScreen;
